__turbopack_context__.v({
  "departureDatePrompt": "ReusableNewsletterForm-module__U1bT5a__departureDatePrompt",
  "form": "ReusableNewsletterForm-module__U1bT5a__form",
});
